import { render } from "./EarlyLeaveTour.vue?vue&type=template&id=5f774d5f"
import script from "./EarlyLeaveTour.vue?vue&type=script&lang=ts"
export * from "./EarlyLeaveTour.vue?vue&type=script&lang=ts"
script.render = render

export default script